module.exports = __webpack_public_path__ + "2112d13290534c8afb22a83c71abf208.svg";